export const PLANMONITOR_WONEN_COMPONENT_ID = 'b3p-planmonitor-wonen';
